import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _, { isEmpty, isNil } from 'lodash'
import { Div, P, Loading } from 'konsys-ui'
import detailType from '../util-functions'
import { CREATE_TRUCK, UPDATE_TRUCK } from '../../../constants/graphql/mutation'
import {
  DRIVER_LIST, TRUCK_OWNER, TRUCK_TYPE, TRUCK_INFO,
} from '../../../constants/graphql/query'
import { detailMode } from '../constants'
import { ActionBar } from '../../../components/truck-components'

const fuelTypeList = [
  { value: 'DIESEL', text: 'ดีเซล' },
  { value: 'DIESELPREMIUM', text: 'ดีเซล พรีเมี่ยม' },
  { value: 'LPG', text: 'LPG' },
  { value: 'NGV', text: 'NGV' },
  { value: 'B10', text: 'ดีเซล B10' },
  { value: 'B20', text: 'ดีเซล B20' },
  { value: 'E85', text: 'แก๊สโซฮอล์ E85' },
  { value: 'E20', text: 'แก๊สโซฮอล์ E20' },
  { value: 'GASOHOL91', text: 'แก๊สโซฮอล์ 91' },
  { value: 'GASOHOL95', text: 'แก๊สโซฮอล์ 95' },
  { value: 'GASOLINE', text: 'เบนซิน' },
]
const fleetList = [
  { value: 'BKK', text: 'BKK' },
  { value: 'CNX', text: 'CNX' },
  { value: 'AUS', text: 'AUS' },
]

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  const [disableButton, setDisableButton] = useState(false)
  const [mutationVariables, setMutationVariables] = useState(isAddMode && {
    fuelType: 'DIESEL',
  })

  let onChangeHandler = (id, value, optional) => {
    if (id === 'driverId') {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
        fleet: optional,
      })
    } else if (id === 'trailerId') {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
        trailerType: optional,
      })
    } else {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
      })
    }
  }

  let selectedList = {}

  selectedList = {
    ...selectedList,
    fleet: fleetList,
    fuelType: fuelTypeList,
  }
  return (
    <Div display='flex' flexDirection='column'>
      <Query
          query={TRUCK_TYPE}
        >
        {
          ({ loading, data: truckType, error }) => {
            if (loading && _.isEmpty(truckType)) return <Loading center='true' />
            if (error) return <P>เกิดข้อผิดพลาด</P>
            selectedList = {
              ...selectedList,
              truckTypeId: truckType.TruckTypes.lists.map(v => (
                { value: v.id, text: `${v.nameTh}  ( น้ำหนัก ${v.minWeight || 0} - ${v.maxWeight || 0} kg.)` }
              )),
            }
            return (
              <Query
                query={TRUCK_OWNER}
              >
              {
                ({ loading: truckOwnerLoading, data: truckOwner, error: truckOwnerError }) => {
                  if (truckOwnerLoading && _.isEmpty(truckOwner)) return <Loading center='true' />
                  if (truckOwnerError) return <P>เกิดข้อผิดพลาด</P>
                  selectedList = {
                    ...selectedList,
                    truckOwnerId: truckOwner.TruckOwners.lists.map(v => ({ value: v.id, text: v.nameTh })),
                    truckOwnerType: truckOwner.TruckOwners.lists.map(v => ({ value: v.type, text: v.type })),
                    truckOwnerObj: truckOwner.TruckOwners.lists.map(v => ({ ownerId: v.id, type: v.type })),
                  }

                  return (
                    <Query
                      query={DRIVER_LIST}
                    >
                    {
                      ({ loading: driverLoading, data: driver, error: driverError }) => {
                        if (driverLoading && _.isEmpty(driver)) return <Loading center='true' />
                        if (driverError) return <P>เกิดข้อผิดพลาด</P>
                        selectedList = {
                          ...selectedList,
                          driverId: driver.DriverList.lists.map(v => (
                            { value: v.id, text: v.fullname, fleet: v.fleetCode }
                          )),
                        }
                        if (isAddMode) { // Add *****************
                          return (
                            <Div>
                              {detailType(props.match.params, onChangeHandler, mutationVariables, selectedList, disableButton, setDisableButton)}
                              <Mutation
                                mutation={isAddMode ? CREATE_TRUCK : UPDATE_TRUCK}
                              >{(doAction, resp) => (
                                <ActionBar
                                  loading={resp.loading}
                                  disabled={_.isUndefined(mutationVariables.plateNumber) || _.isEmpty(mutationVariables.plateNumber)
                                  || _.isUndefined(mutationVariables.driverId)
                                  || _.isUndefined(mutationVariables.truckOwnerId)
                                  || _.isUndefined(mutationVariables.fuelType)
                                  || _.isUndefined(mutationVariables.truckTypeId)}
                                  isAddMode={isAddMode}
                                  isViewMode={isViewMode}
                                  doAction={doAction}
                                  mutationVariables={{ ...mutationVariables }}
                                  props={props}
                                  // pdfInfo={{
                                  //   platenumber: truckInfo.TruckInfo.plateNumber,
                                  // }}
                                />
                              )}
                              </Mutation>
                            </Div>
                          )
                        } return (
                          <Query
                            query={TRUCK_INFO}
                            variables={{ id: props.match.params.id }}
                          >{({ loading: truckInfoLoading, data: truckInfo, error: truckInfoError }) => {
                            if (truckInfoLoading && _.isEmpty(truckInfo)) return <Loading center='true' />
                            if (truckInfoError) return <P>เกิดข้อผิดพลาด</P>
                            const truckData = {
                              ...truckInfo.TruckInfo,
                              driverId: truckInfo.TruckInfo.driver.fullname,
                              truckOwnerId: truckInfo.TruckInfo.owner.nameTh,
                              truckTypeId: `${truckInfo.TruckInfo.type.nameTh} ( น้ำหนัก ${truckInfo.TruckInfo.type.minWeight || 0} - ${truckInfo.TruckInfo.type.maxWeight || 0} kg.)`,
                              truckOwnerType: truckInfo.TruckInfo.owner.type,
                              truckOwnerObj: selectedList.truckOwnerObj,
                            }
                            onChangeHandler = (id, value, optional) => {
                              const parseValue = (id === 'driverId' || id === 'truckOwnerId') ? (_.isNull(value) ? 0 : parseInt(value, 10)) : value
                              if (id === 'driverId') {
                                setMutationVariables({
                                  driverId: truckInfo.TruckInfo.driver.id,
                                  truckOwnerId: truckInfo.TruckInfo.owner.id,
                                  truckTypeId: truckInfo.TruckInfo.type.id,
                                  ...mutationVariables,
                                  fuelType: truckData.fuelType,
                                  [id]: parseValue,
                                  fleet: optional,
                                })
                              } else {
                                setMutationVariables({
                                  driverId: truckInfo.TruckInfo.driver.id,
                                  truckOwnerId: truckInfo.TruckInfo.owner.id,
                                  truckOwnerType: truckData.truckOwnerType,
                                  truckTypeId: truckInfo.TruckInfo.type.id,
                                  ...mutationVariables,
                                  fuelType: truckData.fuelType,
                                  [id]: parseValue,
                                })
                              }
                            }

                            return (
                              <Div>
                                {
                                  detailType(props.match.params, onChangeHandler, mutationVariables, selectedList, disableButton, setDisableButton, truckData)
                                }
                                {/* ================== Footer section ================== */}
                                {
                                  !isViewMode
                                    ? <Mutation
                                      mutation={isAddMode ? CREATE_TRUCK : UPDATE_TRUCK}
                                    >{(doAction, resp) => (
                                      <ActionBar
                                        loading={resp.loading}
                                        disabled={
                                          (
                                            isAddMode
                                            ? (_.isUndefined(mutationVariables.plateNumber) || _.isEmpty(mutationVariables.plateNumber))
                                            : (mutationVariables?.driverId !== truckData?.driver?.id && (isEmpty(mutationVariables?.truckFiles) || isNil(mutationVariables?.truckFiles)))
                                          )
                                          || _.isUndefined(mutationVariables.driverId)
                                          || _.isUndefined(mutationVariables.truckOwnerId)
                                          || _.isUndefined(mutationVariables.fuelType)
                                          || _.isUndefined(mutationVariables.truckTypeId)
                                        }
                                        isAddMode={isAddMode}
                                        isViewMode={isViewMode}
                                        doAction={doAction}
                                        mutationVariables={{ ...mutationVariables }}
                                        props={props}
                                        pdfInfo={{
                                          platenumber: truckInfo.TruckInfo.plateNumber,
                                        }}
                                      />
                                    )}
                                    </Mutation>
                                    : <ActionBar
                                        isAddMode={isAddMode}
                                        isViewMode={isViewMode}
                                        props={props}
                                        pdfInfo={{
                                          platenumber: truckInfo.TruckInfo.plateNumber,
                                        }}
                                      />
                                }
                              </Div>
                            )
                          }}
                          </Query>
                        )
                      }
                    }
                    </Query>
                  )
                }
              }
              </Query>
            )
          }
        }
        </Query>
    </Div>
  )
}

export default Index
export { Index }
